import { Routes, Route } from 'react-router-dom'
import { Account } from '../shop/pages'
import { useConsumerCart, useQueryParams, useShop } from 'shop/hooks'

import { StoreV1 } from './StoreV1'
import { LoadDineIn } from './LoadDineIn'
import {
  CheckoutWrapper,
  ConfirmationWrapper,
  TrackWrapper,
  PayWrapper,
  LandingWrapper,
  PasswordWrapper,
  PurchaseWrapper
} from './wrappers'
import { useRwg } from 'shop/hooks/useRwg'
import { useEffect } from 'react'
import AllTrackers from 'tracker/AllTrackers'
import { expandEnrichedEventData } from 'tracker/helpers'
import { ForgotPassword, ResetPassword } from 'shop/components/Password'

export const Router = () => {
  const { config, currentPartnerStore } = useShop()
  const { cart } = useConsumerCart()
  const { getQueryParam, deleteQueryParam } = useQueryParams()
  const { manageRwgToken } = useRwg(
    config.domain,
    getQueryParam,
    deleteQueryParam
  )

  useEffect(() => {
    manageRwgToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [config.domain])

  /** Update Trackers with new Store data */
  useEffect(() => {
    if (!!currentPartnerStore?.id) {
      expandEnrichedEventData(AllTrackers.getInstance().slerpGA4Tracker, {
        store_id: currentPartnerStore.id,
        store_slug: currentPartnerStore.slug
      })
      expandEnrichedEventData(AllTrackers.getInstance().merchantGA4Tracker, {
        store_id: currentPartnerStore.id,
        store_slug: currentPartnerStore.slug
      })
    }
  }, [currentPartnerStore?.id, currentPartnerStore?.slug])

  /** Update trackers with fulfillment type & order type */
  useEffect(() => {
    if (cart) {
      const orderType = cart.fulfillment.orderType

      const additionalEventData = {
        fulfillment_type: cart.fulfillment.type,
        order_type: orderType
      }

      expandEnrichedEventData(
        AllTrackers.getInstance().slerpGA4Tracker,
        additionalEventData
      )
      expandEnrichedEventData(
        AllTrackers.getInstance().merchantGA4Tracker,
        additionalEventData
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cart?.fulfillment.type, cart?.fulfillment.orderType])

  return (
    <Routes>
      {/* Landing routes */}
      <Route path='' element={<LandingWrapper onClose={() => {}} />} />
      <Route path='browse' element={<LandingWrapper onClose={() => {}} />} />
      <Route path='table/:slug' element={<LoadDineIn />} />

      {/* Password routes */}
      <Route path='/' element={<PasswordWrapper />}>
        <Route path='forgot-password' element={<ForgotPassword />} />
        <Route path='reset-password/:token' element={<ResetPassword />} />
      </Route>

      {/* Store & functionality routes */}
      <Route path='store/:slug' element={<StoreV1 />} />
      <Route path='store/:slug/:product' element={<StoreV1 />} />
      <Route path='account' element={<Account />} />
      <Route path='checkout' element={<CheckoutWrapper />} />
      <Route path='pay' element={<PayWrapper />} />

      {/* Order confirmation routes */}
      <Route path='purchase/:id' element={<PurchaseWrapper />} />
      <Route path='track/:id' element={<TrackWrapper />} />
      <Route
        path='confirmation/:cart_id/:payment_id?'
        element={<ConfirmationWrapper />}
      />
    </Routes>
  )
}
